import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

import { MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import {HttpErrorResponse} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
  })
export class LoginService {

    constructor (
        private router: Router,
        private messageService: MessageChannelService
    ) {}


    public loginCompletouComSucesso(returnUrl: string, categoria: string): void {
        this.loginComSucesso(returnUrl, categoria);
    }


    // Login do Gestor BNDES redirecionado do Cartao BNDES (CBN)
    //
    public loginGestorCbnCompletouComSucesso(returnUrl: string, categoria: string, idAcesso: number, idCtrl: number): void {
        this.loginComSucesso(returnUrl, categoria, idAcesso, idCtrl);
    }


    private loginComSucesso(returnUrl: string, categoria: string, idAcesso?: number, idCtrl?: number): void {

        if (returnUrl.startsWith('http://') || returnUrl.startsWith('https://')) {
            console.log('Url de retorno: ', returnUrl);
            console.log('Redirecionando para: ', returnUrl);
            window.location.href = returnUrl;
            

        } else {
            this.router.navigateByUrl(returnUrl);
        }

        // Teste sem limpar a returnUrl
        // if (sessionStorage) {
        //     sessionStorage.removeItem('returnUrl');
        // }
    }


    public loginCompletouComFalha(categoria: string, error: any, pedirCaptcha: boolean) {

        let mensagemDeErro = 'Usuário ou senha incorretos.';
        if (pedirCaptcha) {
            mensagemDeErro += ' Será necessário preenchimento do Captcha para continuar. Caso a senha esteja correta e o captcha preenchido então verifique se o usuário foi bloqueado.'
        }
        console.log(`Usuário ou senha incorretos - ${error.status}`);

        /*if (error && error.error && error.error.mensagem) {
            mensagemDeErro = error.error.mensagem;
        } */

        console.log('Mensagem de erro: ', mensagemDeErro);

        const mensagem = {
            level: messageLevel.ERROR,
            title: 'Acesso negado',
            message: mensagemDeErro
        };

        this.messageService.addMessage(mensagem);
    }
}
